<p class="mt-2" style="min-height: 24px">
    <mat-slide-toggle color="primary" [checked]="checked" (change)="onToggle()" class="ms-2 mt-2 float-start">
        Checked only
    </mat-slide-toggle>
   
     <button class="float-end ms-2   mat-icon" id="toright-button"mat-button color="primary"  (mousedown)="moveRight()" (mouseup)="clearInterval()">
          <mat-icon inline=true fontIcon="chevron_right" aria-label="To the right" style="height: 15px;"></mat-icon>
    </button>
    <button class="float-end ms-2 mat-icon" id="toleft-button"mat-button color="primary" (mousedown)="moveLeft()" (mouseup)="clearInterval()" >
        <mat-icon inline=true fontIcon="chevron_left" aria-label="To the left" style="height: 15px;"></mat-icon>
    </button>   
</p>    
<div class="mb-2">
    <div class="selected-filter" *ngFor="let s of selectedFilterLabels|keyvalue" [class]="s.key.replaceAll(' ', '_').toLowerCase()">
        <span (click)="openFilter(s)" class="selected-label">{{sortingNiceName(s.key)}}</span>
        <mat-icon (click)="deleteFilterClick.emit(s)">close</mat-icon>
    </div>
    <div class="selected-filter" *ngFor="let d of currentFilters.dynamic|keyvalue">
        <span class="selected-label">{{sortingNiceName(d.key)}}</span>
        <span>: {{d.value}}</span>
        <mat-icon (click)="deleteDynamicFilterClick.emit(d.key)">close</mat-icon>
    </div>
</div>
